/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSimpleDto
 */
export interface UserSimpleDto {
    /**
     * 用户ID；十进制字符串，避免长ID精度丢失
     * @type {string}
     * @memberof UserSimpleDto
     */
    id?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof UserSimpleDto
     */
    name?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof UserSimpleDto
     */
    code?: string;
    /**
     * 登录账号
     * @type {string}
     * @memberof UserSimpleDto
     */
    account?: string;
    /**
     * 等级ID；十进制字符串，无等级时为null
     * @type {string}
     * @memberof UserSimpleDto
     */
    gradeId?: string;
}

/**
 * Check if a given object implements the UserSimpleDto interface.
 */
export function instanceOfUserSimpleDto(value: object): value is UserSimpleDto {
    return true;
}

export function UserSimpleDtoFromJSON(json: any): UserSimpleDto {
    return UserSimpleDtoFromJSONTyped(json, false);
}

export function UserSimpleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSimpleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'account': json['account'] == null ? undefined : json['account'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
    };
}

export function UserSimpleDtoToJSON(json: any): UserSimpleDto {
    return UserSimpleDtoToJSONTyped(json, false);
}

export function UserSimpleDtoToJSONTyped(value?: UserSimpleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'account': value['account'],
        'gradeId': value['gradeId'],
    };
}

